@use 'vars';

//mutiplier is neccesary to make up for the SVG padding
$LOGO_HEIGHT_LARGE: 80px * 1.28;
$LOGO_HEIGHT_MEDIUM: 60px * 1.28;
$LOGO_HEIGHT_SMALL: 60px * 1.28; // for now change up the smallest size to use medium as there are svg clipping issues could change later
$LOGO_CONTAINER_HEIGHT: 30px;
$LOGO_HEIGHT_MINIMIZED: 24px * 1.28;
$LOGO_POSITION_TOP: 25vh;

.iq-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: vars.$margin-xsmall 0;
  padding: 0 vars.$padding-small;
  min-height: $LOGO_HEIGHT_MINIMIZED;
  max-height: $LOGO_HEIGHT_MINIMIZED;

  &__left {
    display: flex;
    align-items: center;
    gap: vars.$gap-large;
    width: 54px;
  }

  &__right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 54px;
  }

  &__cross-icon-container {
    display: flex;
    margin-left: auto;
  }

  &__logo {
    display: flex;
    width: 100%;
    height: $LOGO_CONTAINER_HEIGHT;
    align-items: center;
    justify-content: center;

    &__container {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      transform: translateY($LOGO_POSITION_TOP * 1.2);
      transition: vars.$iq-menu-transition;

      @media screen and (min-width: vars.$softphone-small-width) {
        transform: translateY($LOGO_POSITION_TOP * 1.17);
      }
      @media screen and (min-width: vars.$forced-softphone-max-width) {
        transform: translateY($LOGO_POSITION_TOP * 1.13);
      }
      @media screen and (min-width: vars.$scalable-softphone-min-width) {
        transform: translateY($LOGO_POSITION_TOP * 1.05);
      }

      &--minimized {
        transform: translateY(0);
        transition: transform 0.5s ease-in-out;
      }
    }

    &__image {
      width: $LOGO_HEIGHT_SMALL;
      height: $LOGO_HEIGHT_SMALL;
      overflow: hidden;
      transition: vars.$iq-menu-transition;

      @media screen and (min-width: vars.$softphone-small-width) {
        width: $LOGO_HEIGHT_SMALL;
        height: $LOGO_HEIGHT_SMALL;
      }
      @media screen and (min-width: vars.$forced-softphone-max-width) {
        width: $LOGO_HEIGHT_MEDIUM;
        height: $LOGO_HEIGHT_MEDIUM;
      }
      @media screen and (min-width: vars.$scalable-softphone-min-width) {
        width: $LOGO_HEIGHT_LARGE;
        height: $LOGO_HEIGHT_LARGE;
      }

      &--minimized {
        width: $LOGO_HEIGHT_MINIMIZED;
        height: $LOGO_HEIGHT_MINIMIZED;
      }
    }
  }
}
